let GWP = {};
const GWPSchema = document.querySelector('[data-GWP-schema]');
if (GWPSchema) {
  GWP = JSON.parse(GWPSchema.innerHTML);
}

class customGWPJS {
    constructor() {
        this.ajaxCart = document.querySelector('cart-form');
        // Stored reference for event delegation — prevents duplicate listeners across showFreeProduct calls
        this._boundAddGift = null;
    }

    cartGWP() {
        this.ajaxCart = document.querySelector('cart-form');
        const cart = window.globalSpace.cart;
        let GWPGift = false;
        let [threashouldValue, existedFreeProduct, existedFreeProductLine] = [null, null, null];
        let [finalThreshouldAmount, originalThreshouldAmount, updateQty] = [null, null, false];
        let [eligibleThreshould, eligibleFreeProduct, eligibleFreeProductJSON, eligibleFreeProduct_2, eligibleFreeProductJSON_2, cartTotal] = [null, null, null, null, null, 0];

        cart.items.forEach((product, index) => {
            if (product.properties && product.properties['product_type'] == 'GWP Gift') {
                GWPGift = true;
                existedFreeProductLine = index + 1;
                existedFreeProduct = product.variant_id;
                if (product.quantity > 1) updateQty = true;
                // Use optional chaining — GWP.threashould_1 may be undefined if schema not loaded
                if (product.variant_id == GWP.threashould_1?.['gwp_pro'] || product.variant_id == GWP.threashould_1?.['gwp_pro_2']) {
                    threashouldValue = 1;
                }
            } else {
                if (product.product_type != 'Gift Card') {
                    cartTotal += product.final_line_price;
                }
            }
        });

        if (GWPGift) this.syncGWPAttribute(cart);

        if (GWP.enable == 'true' && cartTotal >= GWP.threashould_1?.['amount']) {
            eligibleThreshould = 1;
            const selectedThreashould = GWP[`threashould_${eligibleThreshould}`];
            [eligibleFreeProduct, eligibleFreeProductJSON, eligibleFreeProduct_2, eligibleFreeProductJSON_2] = [
                selectedThreashould.gwp_pro, selectedThreashould.gwp_pro_JSON,
                selectedThreashould.gwp_pro_2, selectedThreashould.gwp_pro_JSON_2
            ];
            [finalThreshouldAmount, originalThreshouldAmount] = [selectedThreashould.amount, selectedThreashould.original_amount];
        }

        const removeProduct = JSON.stringify({ line: existedFreeProductLine, quantity: 0 });

        // Fix: GWP == undefined can never be true since GWP is always initialised as {}.
        // Check !GWP.enable to detect an unconfigured/disabled GWP schema.
        if ((!GWP.enable || eligibleThreshould == null) && GWPGift) {
            this.updateGWPvariant(removeProduct, () => {
                if (this.ajaxCart) this.ajaxCart.getCartData();
            });
        } else if (
            (threashouldValue && threashouldValue != eligibleThreshould && (eligibleFreeProduct != null || eligibleFreeProduct_2 != null)) ||
            (existedFreeProduct != null && existedFreeProduct != eligibleFreeProduct && existedFreeProduct != eligibleFreeProduct_2)
        ) {
            this.updateGWPvariant(removeProduct, () => {
                if (this.ajaxCart) this.ajaxCart.getCartData();
                this.showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2);
            });
        } else if (updateQty) {
            const updateProduct = JSON.stringify({ line: existedFreeProductLine, quantity: 1 });
            this.updateGWPvariant(updateProduct, () => {
                if (this.ajaxCart) this.ajaxCart.getCartData();
            });
        } else if (eligibleThreshould != null && eligibleFreeProduct != null && !GWPGift) {
            this.showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2);
        } else {
            const freeGiftParent = document.querySelector('[data-freeGift]');
            if (freeGiftParent) {
                freeGiftParent.style.display = 'none';
                freeGiftParent.innerHTML = '';
            }
        }
    }

    // Write the _GWP_amount cart attribute only when a gift is in the cart and the stored value is stale
    syncGWPAttribute(cart) {
        if (GWP.enable != 'true' || GWP.attribute_amount == null) return;
        if (String(cart.attributes?._GWP_amount) === String(GWP.attribute_amount)) return;

        const body = JSON.stringify({ attributes: { _GWP_amount: GWP.attribute_amount } });
        fetch(`${window.routes.cart_update_url}`, { ...Utility.fetchConfig(), ...{ body } })
            .then(response => {
                if (response.ok) cart.attributes = { ...cart.attributes, _GWP_amount: String(GWP.attribute_amount) };
            })
            .catch((e) => console.error('Error updating GWP attribute:', e));
    }

    updateGWPvariant(body, callback) {
        const checkoutBtn = document.querySelector('.checkout-btn');
        fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body } })
            .then(response => response.json())
            .then(response => { if (typeof callback == 'function') return callback(response); })
            .catch((e) => { console.error(e); return callback(e); })
            .finally(() => { if (checkoutBtn) checkoutBtn.classList.remove('disabled'); });
    }

    // Shared helper — avoids duplicating the card HTML for each gift option
    _buildGiftItemHTML(product, originalThreshouldAmount) {
        return `
        <div class="list-item d-flex gap-2 mt-4">
          <div class="card-img flex-shrink-0" style="width: 100px;">
            <div class="d-block">
              <img class="img-fluid item-img" src="${product.featured_image}" loading="lazy" width="75" height="95" />
            </div>
          </div>
          <div class="card-body">
            <div class="cart-item-text">
              <p class="card-title fw-semibold fs-md mb-1 d-inline-block" style="line-height: 1.3;">${product.title}</p>
              <div class="cart-price">
                <span class="orgi_price ajaxcart__price">FREE  <del>${Utility.formatMoney(product.compare_at_price, window.globalSpace.money_format)}</del></span>
              </div>
              <div class="quantity-box mt-3">
                <button type="button" name="add" class="btn btn-primary btn-sm add-to-cart"
                  data-originalThreshouldAmount="${originalThreshouldAmount}"
                  data-addID="${product.variants[0].id}"
                  data-addFreeItem>
                  <span>Add to cart</span>
                </button>
              </div>
            </div>
          </div>
        </div>`;
    }

    showFreeProduct(originalThreshouldAmount, finalThreshouldAmount, eligibleFreeProductJSON, eligibleFreeProductJSON_2) {
        if (eligibleFreeProductJSON == null && eligibleFreeProductJSON_2 == null) return;

        // Either gift product may be unset (null in the GWP schema)
        let freeProductsHTML = eligibleFreeProductJSON ? this._buildGiftItemHTML(eligibleFreeProductJSON, originalThreshouldAmount) : '';
        if (eligibleFreeProductJSON_2) {
            freeProductsHTML += `<div class="pt-3">${this._buildGiftItemHTML(eligibleFreeProductJSON_2, originalThreshouldAmount)}</div>`;
        }

        const freeProductwrapperHTML = `
          <div>
            <div class="col-12 gift_prod_heading mt-3">
              <div class="general-text mb-5 fw-medium" style="font-size:14px;">Choose your gift</div>
            </div>
            <div data-gwp-container>${freeProductsHTML}</div>
          </div>`;

        const freeGiftParent = document.querySelector('[data-freeGift]');
        if (!freeGiftParent) return;

        freeGiftParent.innerHTML = freeProductwrapperHTML;
        freeGiftParent.style.display = 'block';

        // Use event delegation on the parent — remove any previous listener before attaching
        // a new one to prevent stacking across multiple showFreeProduct calls.
        if (this._boundAddGift) {
            freeGiftParent.removeEventListener('click', this._boundAddGift);
        }
        this._boundAddGift = (event) => {
            const addBtn = event.target.closest('[data-addFreeItem]');
            if (!addBtn) return;
            event.preventDefault();

            const body = JSON.stringify({
                id: addBtn.getAttribute('data-addid'),
                quantity: 1,
                properties: {
                    product_type: 'GWP Gift',
                    spend_over: addBtn.getAttribute('data-originalThreshouldAmount')
                }
            });

            document.querySelector('[data-gwp-container]')?.classList.add('loading');
            fetch(`${window.routes.cart_add_url}`, { ...Utility.fetchConfig(), ...{ body } })
                .then(response => response.json())
                .then(() => {
                    if (this.ajaxCart) this.ajaxCart.getCartData();
                    document.querySelector('[data-gwp-container]')?.classList.remove('loading');
                    freeGiftParent.style.display = 'none';
                    freeGiftParent.innerHTML = '';
                })
                .catch((e) => {
                    console.error('Error adding free gift:', e);
                    document.querySelector('[data-gwp-container]')?.classList.remove('loading');
                });
        };
        freeGiftParent.addEventListener('click', this._boundAddGift);
    }
}

const newCustomGWP = new customGWPJS();
newCustomGWP.cartGWP();
